import emitter from "tiny-emitter/instance"
import {GlobalTenant} from "@irati/types"
import storage from "../helpers/storage"
import Regions from "../enums/Regions"

export const DEFAULT_REGION = Regions.EU

const KEY = "pbregion"
const GLOBAL_TENANT_KEY = "pbglobaltenant"
const EVENT = "PB_REGION_UPDATE"

class Region {
  set(value: string) {
    storage.setItem(KEY, value)
    emitter.emit(EVENT, value)
  }

  get(): string {
    return storage.getItem(KEY) || ""
  }

  setGlobalTenant(value: GlobalTenant) {
    storage.setItem(GLOBAL_TENANT_KEY, JSON.stringify(value))
    emitter.emit(EVENT, value)
  }

  getGlobalTenant(): GlobalTenant {
    let tenant = {tenantId: "", subdomain: "", region: this.get()}
    try {
      tenant = JSON.parse(storage.getItem(GLOBAL_TENANT_KEY) || "")
    } catch (e) {
      // no-op
    }
    return tenant
  }

  addEventListener(cb: () => void) {
    emitter.on(EVENT, cb)
  }

  removeEventListener(cb: () => void) {
    emitter.off(EVENT, cb)
  }
}

export default new Region()
